import React, { ChangeEvent, useCallback, useRef } from 'react';
import classNames from 'classnames';

import s from './TextArea.module.scss';
import Label from '../shared/Label';

export type TextAreaProps = {
  description?: string;
  disabled?: boolean;
  error?: string;
  hint?: string;
  id?: string;
  label: string;
  name?: string;
  onChange: (value: string, event: ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  optional?: boolean;
  placeholder?: string;
  rows?: number;
  style?: React.CSSProperties;
  value?: string | null;
};

const TextArea: React.FC<TextAreaProps> = ({
  description,
  disabled,
  error,
  hint,
  id,
  label,
  name,
  onChange,
  onFocus,
  onBlur,
  optional,
  placeholder,
  rows,
  style,
  value,
}) => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const handleChange = useCallback((event: ChangeEvent<HTMLTextAreaElement>): void => {
    onChangeRef.current(event.target.value, event);
  }, []);

  return (
    <Label
      label={label}
      required={!optional}
      description={description}
      errorMessage={error}
      hint={hint}
    >
      <textarea
        id={id}
        name={name}
        value={value ?? ''}
        placeholder={placeholder}
        required={!optional}
        onChange={handleChange}
        className={classNames(s['input-field'], s.textarea, !!error && s.error)}
        disabled={disabled}
        rows={rows}
        style={style}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </Label>
  );
};

export default TextArea;
